const prefix = 'fasr';
const iconName = 'italic';
const width = 384;
const height = 512;
const aliases = [];
const unicode = 'f033';
const svgPathData = 'M128 32h24H360h24V80H360 291.3L144.7 432H232h24v48H232 24 0V432H24 92.7L239.3 80H152 128V32z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
